import { Link, NavLink } from 'react-router-dom';
import { LogOut } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { CompTag } from '@/components/CompTag';
import { Countdown } from '@/components/Countdown';
import { LoomliteMark } from '@/components/LoomliteMark';
import { useAuth } from '@/contexts/AuthContext';
import { useCompetitions } from '@/hooks/useCompetitions';
import { cn } from '@/lib/utils';

const navItem = ({ isActive }: { isActive: boolean }) =>
	cn(
		'rounded-md px-3 py-2 text-sm transition-colors',
		isActive ? 'text-loomlite-text' : 'text-loomlite-dim hover:text-loomlite-text',
	);

export function SiteHeader() {
	const { user, signOut } = useAuth();
	const { data: competitions } = useCompetitions();
	const featured = competitions?.find((c) => c.Status === 'open') ?? competitions?.[0];

	return (
		<header className="sticky top-0 z-40 border-b border-loomlite-border bg-loomlite-ink/70 backdrop-blur">
			<div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-5 py-3">
				<Link to="/" className="flex items-center">
					<LoomliteMark size={26} />
				</Link>

				{featured && (
					<div className="hidden items-center gap-3 md:flex">
						<CompTag color={featured.Status === 'open' ? 'gold' : 'muted'}>
							{featured.Name}
							{featured.Status === 'open' ? ' · Featured' : ` · ${featured.Status}`}
						</CompTag>
						{featured.Status === 'open' && (
							<Countdown compact targetIso={featured.SubmissionCloseAt} />
						)}
					</div>
				)}

				<nav className="flex items-center gap-1">
					<NavLink to="/" end className={navItem}>
						Browse
					</NavLink>
					{user && (
						<NavLink to="/my-submissions" className={navItem}>
							My submissions
						</NavLink>
					)}
					{user ? (
						<Button variant="ghost" size="sm" onClick={signOut}>
							<LogOut className="mr-1 h-4 w-4" /> Sign out
						</Button>
					) : (
						<Button asChild size="sm">
							<Link to="/login">Sign in</Link>
						</Button>
					)}
				</nav>
			</div>
		</header>
	);
}
